import { observer } from 'mobx-react-lite';
import { Segment } from 'semantic-ui-react';
import PermitContentActionPage from './PermitContentActionPage';
import PermitContentPermits from './PermitContentPermits';

export default observer(function PermitContent() {
    return (
        <Segment basic>
            <Segment>
                <PermitContentActionPage />
            </Segment>
            <Segment>
                <PermitContentPermits />
            </Segment>
        </Segment>
    )
})